<template>
    <section id="wishlist" class="grid-view wishlist-items align-content-center">
        <div class="card ecommerce-card">
            <div class="item-img text-center  mx-auto">
                <a href="https://sowl.co/s/2EDh1" target="_blank">
                    <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-chatgpt-ebook-right.png"
                        class="img-fluid"
                        alt="number-one-credit-repair-ebook-you-are-the-creditfixrr" style="width:200px;"/>
                </a>
            </div>
            <div class="card-body">
                <div class="item-wrapper">
                    <div class="item-rating">
                        <ul class="unstyled-list list-inline">
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                        </ul>
                    </div>
                    <div class="item-cost">
                        <h6 class="item-price">$19.97</h6>
                    </div>
                </div>
                <div class="item-name">
                    <a href="https://sowl.co/s/2EDh1" target="_blank">ChatGPT with Creditfixrr.com</a>
                </div>
            </div>
            <div class="item-options text-center">
                <a href="https://sowl.co/s/2EDh1" type="button" class="btn btn-primary btn-cart" target="_blank">
                    <i data-feather="shopping-bag"></i>
                    <span class="add-to-cart">Buy Now</span>
                </a>
            </div>
        </div>
        <div class="card ecommerce-card">
            <div class="item-img text-center  mx-auto">
                <a href="https://sowl.co/s/HbC6A" target="_blank">
                    <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-100-dispute-reasons-ebook-right.png"
                        class="img-fluid"
                        alt="best-student-loan-removal-guide" style="width:200px;"/>
                </a>
            </div>
            <div class="card-body">
                <div class="item-wrapper">
                    <div class="item-rating">
                        <ul class="unstyled-list list-inline">
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                        </ul>
                    </div>
                    <div class="item-cost">
                        <h6 class="item-price">$19.97</h6>
                    </div>
                </div>
                <div class="item-name">
                    <a href="https://sowl.co/s/HbC6A" target="_blank">100+ Dispute Reasons</a>
                </div>
            </div>
            <div class="item-options text-center">
                <a href="https://sowl.co/s/HbC6A" type="button" class="btn btn-primary btn-cart" target="_blank">
                    <i data-feather="shopping-bag"></i>
                    <span class="add-to-cart">Buy Now</span>
                </a>
            </div>
        </div>
        <div class="card ecommerce-card">
            <div class="item-img text-center  mx-auto">
                <a href="https://sowl.co/s/bhEaCg" target="_blank">
                    <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-business-funding-ebook-right.png"
                        class="img-fluid" alt="best-student-loan-removal-guide" style="width:200px;"/>
                </a>
            </div>
            <div class="card-body">
                <div class="item-wrapper">
                    <div class="item-rating">
                        <ul class="unstyled-list list-inline">
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                        </ul>
                    </div>
                    <div class="item-cost">
                        <h6 class="item-price">$49.97</h6>
                    </div>
                </div>
                <div class="item-name">
                    <a href="https://sowl.co/s/bhEaCg" target="_blank">Business Structure & Funding</a>
                </div>
            </div>
            <div class="item-options text-center">
                <a href="https://sowl.co/s/bhEaCg" type="button" class="btn btn-primary btn-cart" target="_blank">
                    <i data-feather="shopping-bag"></i>
                    <span class="add-to-cart">Buy Now</span>
                </a>
            </div>
        </div>
         <div class="card ecommerce-card">
             <div class="item-img text-center  mx-auto">
                 <a href="https://sowl.co/s/92Sgo" target="_blank">
                     <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-student-loan-removal-ebook-left.png"
                         class="img-fluid" alt="best-student-loan-removal-guide" style="width:200px;"/>
                 </a>
             </div>
             <div class="card-body">
                 <div class="item-wrapper">
                     <div class="item-rating">
                         <ul class="unstyled-list list-inline">
                             <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                             <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                             <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                             <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                             <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                         </ul>
                     </div>
                     <div class="item-cost">
                         <h6 class="item-price">$39.97</h6>
                     </div>
                 </div>
                 <div class="item-name">
                     <a href="https://sowl.co/s/92Sgo" target="_blank">Student Loan Removal Guide</a>
                 </div>
             </div>
             <div class="item-options text-center">
                 <a href="https://sowl.co/s/92Sgo" type="button" class="btn btn-primary btn-cart" target="_blank">
                     <i data-feather="shopping-bag"></i>
                     <span class="add-to-cart">Buy Now</span>
                 </a>
             </div>
         </div>
         <div class="card ecommerce-card">
            <div class="item-img text-center  mx-auto">
                <a href="https://sowl.co/s/cd9Qy"  target="_blank">
                    <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-dispute-letter-library-ebook-right.png"
                        class="img-fluid" alt="best-student-loan-removal-guide" style="width:200px;"/>
                </a>
            </div>
            <div class="card-body">
                <div class="item-wrapper">
                    <div class="item-rating">
                        <ul class="unstyled-list list-inline">
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                        </ul>
                    </div>
                    <div class="item-cost">
                        <h6 class="item-price">$29.97</h6>
                    </div>
                </div>
                <div class="item-name">
                    <a href="https://sowl.co/s/cd9Qy"  target="_blank">Dispute Letter Library</a>
                </div>
            </div>
            <div class="item-options text-center">
                <a href="https://sowl.co/s/cd9Qy" type="button" class="btn btn-primary btn-cart"  target="_blank">
                    <i data-feather="shopping-bag"></i>
                    <span class="add-to-cart">Buy Now</span>
                </a>
            </div>
        </div>
        <!-- add Creditfixrr E-Book Bundle section -->
        <div class="card ecommerce-card">
            <div class="item-img text-center  mx-auto">
                <a href="https://sowl.co/s/vZmBd"  target="_blank">
                    <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/Creditfixrr%20E-book%20Bundle.png"
                        class="img-fluid" alt="best-student-loan-removal-guide" style="width:200px;"/>
                </a>
            </div>
            <div class="card-body">
                <div class="item-wrapper">
                    <div class="item-rating">
                        <ul class="unstyled-list list-inline">
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                        </ul>
                    </div>
                    <div class="item-cost">
                        <h6 class="item-price">$197.97</h6>
                    </div>
                </div>
                <div class="item-name">
                    <a href="https://sowl.co/s/vZmBd"  target="_blank">Creditfixrr.com E-Book Bundle</a>
                </div>
            </div>
            <div class="item-options text-center">
                <a href="https://sowl.co/s/vZmBd" type="button" class="btn btn-primary btn-cart"  target="_blank">
                    <i data-feather="shopping-bag"></i>
                    <span class="add-to-cart">Buy Now</span>
                </a>
            </div>
        </div>
        <!-- end Creditfixrr E-Book Bundle -->
        <!-- add Creditfixrr E-Book Bundle section -->
        <div class="card ecommerce-card">
            <div class="item-img text-center  mx-auto">
                <a href="https://sowl.co/s/vZmBd"  target="_blank">
                    <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-ebook.png"
                        class="img-fluid" alt="best-student-loan-removal-guide" style="width:200px;"/>
                </a>
            </div>
            <div class="card-body">
                <div class="item-wrapper">
                    <div class="item-rating">
                        <ul class="unstyled-list list-inline">
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                            <li class="ratings-list-item"><i data-feather="star" class="filled-star"></i></li>
                        </ul>
                    </div>
                    <div class="item-cost">
                        <h6 class="item-price">$27.99</h6>
                    </div>
                </div>
                <div class="item-name">
                    <a href="https://sowl.co/s/ykpjo"  target="_blank">You Are The Creditfixrr Ebook</a>
                </div>
            </div>
            <div class="item-options text-center">
                <a href="https://sowl.co/s/ykpjo" type="button" class="btn btn-primary btn-cart"  target="_blank">
                    <i data-feather="shopping-bag"></i>
                    <span class="add-to-cart">Buy Now</span>
                </a>
            </div>
        </div>
        <!-- end Creditfixrr E-Book Bundle -->
    </section>
</template>
<script>
import {ref} from 'vue'

export default{
    components:{
    },
    setup(){
        return{
            landing_data: ref({})
        }
    },
    mounted(){
    }
}
</script>
